import React, { useEffect, useState } from 'react';
import { getCurrentUserAttributes } from '../../sso/components/oauth/auth-provider-methods';
import { stripToken } from '../../../general/js/utils/jwt-utils';
import { hasValue, safeParseJSON, stringToArray } from '../../../general/js/general-helpers';
import { addQueryParams } from '../../../general/js/utils';

export function IMGAMatchupsGameLayout(props) {
    const {
        allowedUserAttributes,
        iFrameDatasource,
        tokenHeader,
        tokenQueryKey
    } = props;

    const [userIdTokenShortened, setUserIdTokenShortened] = useState(undefined);

    useEffect(() => {
        getCurrentUserAttributes()
            .then((user) => {
                setUserIdTokenShortened(
                    stripToken(
                        user.idToken,
                        stringToArray(allowedUserAttributes),
                        '',
                        safeParseJSON(tokenHeader)
                    )
                );
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    if (
        !hasValue(userIdTokenShortened) ||
        !hasValue(iFrameDatasource) ||
        !hasValue(iFrameDatasource.source)) {
        return null;
    }

    const iFrameSrc = addQueryParams(iFrameDatasource.source, [
        {
            key: tokenQueryKey,
            value: userIdTokenShortened
        }
    ]);

    return (
        <iframe src={iFrameSrc}></iframe>
    );
}
